import moment, { Moment } from 'moment-timezone';
import { secondsInTimeFormat } from '../../../../services/filters';

export const convertDateToMoment = (dateString: string, timeZone?: string): Moment | '' => {
	if (!dateString) {
		return '';
	}
	if (timeZone) {
		return moment(dateString).tz(timeZone);
	}
	return moment(dateString);
};

export const convertSecondsToMoment = (seconds: number): Moment => {
	return moment(secondsInTimeFormat(seconds), 'HH:mm:ss');
};

export const convertMomentToSeconds = (momentValue: Moment): number => {
	return moment.duration(momentValue.format('HH:mm:ss')).asSeconds();
};

export const getTimeWindow = (noEarlierThan: string, noLaterThan: string, timeZone: string): (Moment | '')[] => {
	const noEarlierThanValue = convertDateToMoment(noEarlierThan, timeZone);
	const noLaterThanValue = convertDateToMoment(noLaterThan, timeZone);
	return [noEarlierThanValue, noLaterThanValue];
};

export const getDateFieldValue = (date: Moment | '', timeZone?: string) => {
	if (!date) {
		return null;
	}
	let dateToFormat = date;
	if (timeZone) {
		dateToFormat = moment.tz(dateToFormat.format('YYYY-MM-DD HH:mm:ss.SSS'), timeZone);
	}
	return moment(dateToFormat.toDate()).toISOString();
};
